const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    search: `${API_URL}/product-window/search`,
    data: `${API_URL}/product-window/data`
};

export default apiUrls;
